import React, { useEffect, useRef, useState } from "react";
import { bp } from "./slug";
import { useNavigate } from "react-router-dom";
import { api } from "./api";
import { lastProgramme, WORKSPACES } from "./Shell";

type Hit = { programme_id: string; programme: string; key: string; type: string; title: string; status: string };
const TYPE_SCREEN: Record<string, string> = { requirement: "conditions", source: "sources", proposal: "review", route: "routes", participant: "commitments", notice: "notices",
  baseline: "approval", evidence: "evidence", appointment: "examination", packet: "packet", correction: "correction", handover: "handover", task: "reuse", cost: "economics",
  domain: "configure", requirement_baseline: "configure", obligation: "cash", funding: "cash", component: "configure", remaining_item: "remaining", lifetime_cost: "lifetime" };

export function CommandPalette({ close }: { close: () => void }) {
  const [q, setQ] = useState("");
  const [hits, setHits] = useState<Hit[]>([]);
  const [i, setI] = useState(0);
  const nav = useNavigate();
  const ref = useRef<HTMLInputElement>(null);
  const pid = lastProgramme();
  useEffect(() => { ref.current?.focus(); }, []);
  useEffect(() => {
    if (q.length < 2) { setHits([]); return; }
    const t = setTimeout(() => { api<Hit[]>(`/search?q=${encodeURIComponent(q)}`).then(setHits).catch(() => setHits([])); }, 180);
    return () => { clearTimeout(t); };
  }, [q]);
  const cmds = [{ label: "Programmes", to: "/" }, { label: "Library", to: "/library" }, { label: "Integrations", to: "/integrations" }, { label: "Workspace health", to: "/operations" },
    { label: "People and access", to: "/settings" },
    ...(pid ? WORKSPACES.flatMap((w) => w.screens.map(([id, l]) => ({ label: `${w.label}: ${l}`, to: `${bp(pid)}/${id}` }))) : [])]
    .filter((c) => !q || c.label.toLowerCase().includes(q.toLowerCase()));
  const items = [...cmds.map((c) => ({ label: c.label, sub: "Go to", to: c.to })),
    ...hits.map((h) => ({ label: h.title, sub: `${h.programme} · ${h.type} · ${h.status || ""}`, to: `${bp(h.programme_id)}/${TYPE_SCREEN[h.type] || "configure"}?record=${h.key}` }))];
  const go = (to: string) => { nav(to); close(); };
  return (
    <div className="dialog-scrim" onClick={close}>
      <div className="dialog palette" role="dialog" aria-modal="true" aria-label="Command palette" onClick={(e) => e.stopPropagation()} data-testid="command-palette">
        <input ref={ref} value={q} placeholder="Search records you may see, or jump to a screen" onChange={(e) => { setQ(e.target.value); setI(0); }} data-testid="command-palette-input"
               onKeyDown={(e) => {
                 if (e.key === "Escape") close();
                 if (e.key === "ArrowDown") setI(Math.min(i + 1, items.length - 1));
                 if (e.key === "ArrowUp") setI(Math.max(i - 1, 0));
                 if (e.key === "Enter" && items[i]) go(items[i].to);
               }} />
        <div className="palette-list">{items.slice(0, 14).map((it, n) => (
          <button key={it.to + n} className={`palette-item ${n === i ? "on" : ""}`} onClick={() => go(it.to)} data-testid={`palette-item-${n}`}>
            <span>{it.label}</span><small>{it.sub}</small></button>))}
          {!items.length && <div className="emptyline">No permitted matches.</div>}
        </div>
      </div>
    </div>
  );
}
